import * as React from 'react';

import EnterpriseAutoEnrolledCoursesDataProvider from 'bundles/unified-common/providers/EnterpriseAutoEnrolledCoursesDataProvider';
import EnterpriseCareerAcademyVariantDataProvider from 'bundles/unified-common/providers/EnterpriseCareerAcademyVariantDataProvider';
import EnterpriseModalManagerProvider from 'bundles/unified-common/providers/EnterpriseModalManagerProvider';
import EnterpriseProductFeaturesDataProvider from 'bundles/unified-common/providers/EnterpriseProductFeaturesDataProvider';
import EnterpriseProgramDataProvider from 'bundles/unified-common/providers/EnterpriseProgramDataProvider';
import EnterpriseAdminEnrollmentDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseAdminEnrollmentDataProvider';

/**
 * @description This should be included for any page that is served in the enterprise context.
 * Each of these pages likely needs access to basic program info, but critical components
 * like the enterprise page header/footer and enterprise modal manager rely on this data to
 * serve critical functionality.
 */
const EnterprisePageDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseProgramDataProvider>
      <EnterpriseProductFeaturesDataProvider>
        <EnterpriseAutoEnrolledCoursesDataProvider>
          <EnterpriseCareerAcademyVariantDataProvider>
            <EnterpriseAdminEnrollmentDataProvider>
              <EnterpriseModalManagerProvider>{children}</EnterpriseModalManagerProvider>
            </EnterpriseAdminEnrollmentDataProvider>
          </EnterpriseCareerAcademyVariantDataProvider>
        </EnterpriseAutoEnrolledCoursesDataProvider>
      </EnterpriseProductFeaturesDataProvider>
    </EnterpriseProgramDataProvider>
  );
};

export default EnterprisePageDataProvider;
